import { useMemo } from "react";

export type AiPipelineElapsedTimerProps = {
  elapsedMs: number;
  className?: string;
};

export function formatAiPipelineElapsed(elapsedMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export const AiPipelineElapsedTimer = ({
  elapsedMs,
  className = "",
}: AiPipelineElapsedTimerProps) => {
  const label = useMemo(() => formatAiPipelineElapsed(elapsedMs), [elapsedMs]);

  return (
    <span className={className} aria-label={`Elapsed time ${label}`}>
      {label}
    </span>
  );
};
